export default __webpack_public_path__ + "static/media/rote_raketa_playeronly.6f702001.png";